import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";
import DataTable from "../../../shared/Tables/DataTable";
import institutionService from "../../../services/institutionService";
import ActionCell from "./components/ActionCell";

function InstitutionList() {
  const [institutions, setInstitutions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchInstitutions(page, limit, search);
  }, [page, limit, search]);

  const fetchInstitutions = async (currentPage, currentLimit, currentSearch) => {
    setLoading(true);
    try {
      const response = await institutionService.getAll({
        page: currentPage + 1,
        limit: currentLimit,
        q: currentSearch,
        searchFields: "name,website",
        select: "name,website"
      });
      setInstitutions(response.data || []);
      setTotalCount(response.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching institutions:", error);
      setLoading(false);
    }
  };

  const columns = [
    { Header: "Nombre", accessor: "name", align: "left" },
    { Header: "Sitio Web", accessor: "website", align: "left" },
    { Header: "Acciones", accessor: "actions", align: "center" },
  ];

  const rows = institutions.map((inst) => ({
    name: <MDTypography variant="button" fontWeight="medium">{inst.name}</MDTypography>,
    website: <MDTypography variant="caption">{inst.website}</MDTypography>,
    actions: (
      <MDBox display="flex" alignItems="center">
        <ActionCell id={inst._id} action="details" icon="visibility" color="info" />
        <ActionCell id={inst._id} action="edit" icon="edit" color="info" />
        <ActionCell id={inst._id} action="delete" icon="delete" color="primary" onDelete={fetchInstitutions} />
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <MDButton
          component={Link}
          to="/institutions/new"
          variant="gradient"
          color="info"
        >
          Nuevo
        </MDButton>
      </MDBox>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Instituciones</MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: limit, entries: [5, 10, 15, 20, 25] }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  isManualPagination={true}
                  pageCount={Math.ceil(totalCount / limit)}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newLimit) => setLimit(newLimit)}
                  onSearchChange={(newSearch) => {
                    setSearch(newSearch);
                    setPage(0);
                  }}
                  totalEntries={totalCount}
                  loading={loading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default InstitutionList;